import { render, staticRenderFns } from "./SaidaSetor.vue?vue&type=template&id=b78734e0&scoped=true&"
import script from "./SaidaSetor.vue?vue&type=script&lang=js&"
export * from "./SaidaSetor.vue?vue&type=script&lang=js&"
import style0 from "./SaidaSetor.vue?vue&type=style&index=0&id=b78734e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78734e0",
  null
  
)

export default component.exports